/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useEffect, useState} from 'react';
import {InnerVerticalTabs} from '../../../components/Tabs/InnerVerticalTabs/InnerVerticalTabs';
import Content from './Content';
import {StringParam, useQueryParam} from "use-query-params";
import {useAppSelector} from "../../../../redux/hooks";
import {selectCurrentUser} from "../../../../redux/ducks/AccessControl/slice";
import {ObjectDef, versionsTabUrlParam} from '../constants';
import {ETrackedItemTypes} from "../../../../constants/trackedItems";
import {useSetRecentlyViewedWithDeps} from "../../../../hooks/useSetRecentlyViewedWithDeps";


interface ObjectDetailsTabProps {
  objectData: ObjectDef[]
  isCustomObject: boolean
}

const ObjectDetailsTab = (props: ObjectDetailsTabProps) => {
  const objectData = props.objectData
  const isCustomObject = props.isCustomObject
  const [tabs, setTabs] = useState<any>([])
  const [selectedTab, setSelectedTab] = useQueryParam(versionsTabUrlParam, StringParam)
  const gmid = useAppSelector(state => selectCurrentUser(state).id)

  /**
   * Recently viewed
   */
  const recentlyViewedParams = null
  const setRecentlyViewed = useSetRecentlyViewedWithDeps(recentlyViewedParams, false, true)

  useEffect(() => {
    const localTabs: any[] = []
    objectData.forEach((object: ObjectDef) => {
      const trackedItemUid = object.id
      localTabs.push({
        "name": `Version ${object.version}`,
        trackedItemUid,
        "content": <Content object={object}/>
      })
      if (isCustomObject) { // TODO: Are custom objects the only ones that could have multiple versions?

      }
      setSelectedTab(trackedItemUid)
      // set recently viewed
      const time = Date.now()
      const body = {
        gmid,
        trackedItemUid: trackedItemUid,
        trackedItemType: ETrackedItemTypes.OBJECT,
        requestType: 'addRecentlyViewed',
        partitionKey: 'Jama',
        time
      }
      setRecentlyViewed(body)
    })
    setTabs(localTabs)
  }, [objectData])

  return (<>
    <div style={{flexGrow: 1, display: 'flex', height: '100%'}}>
      {
        isCustomObject ? (tabs?.[0]?.content ?? null) :
          <InnerVerticalTabs tabs={tabs} favoriteType={ETrackedItemTypes.OBJECT} uid={versionsTabUrlParam}/>
      }
    </div>
  </>)
}
export default ObjectDetailsTab
